import { createAsyncThunk } from '@reduxjs/toolkit';
import type { LeaderboardError, LeaderboardResponse } from '../api/leaderboard.types';
import { axiosInstance } from '@/shared/api/instance';

export const fetchLeaderboard = createAsyncThunk(
  'leaderboard/fetchLeaderboard',
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get<LeaderboardResponse>(
        '/app/leaderboard/current-month/',
      );
      return {
        items: response.data.leaderboard,
        period: response.data.period,
      };
    } catch (error: any) {
      return thunkAPI.rejectWithValue({
        message: error.response?.data?.message || error.message,
        code: error.response?.status || 500,
      } as LeaderboardError);
    }
  },
);
